import boletaApi from "./boletaApi";

export const newCompanyP = async (body) => {
  try {
    return await boletaApi.post("/newCompanyProfile", body);
  } catch (error) {
    const { response } = error;
    return response;
  }
};
